import { ConfigProvider } from "antd";
import en_US from "antd/lib/locale/en_US";
import fa_IR from "antd/lib/locale/fa_IR";
import React from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import GlobalStyle from "src/globalStyles";
import { LoadingC } from "src/shared/components";
import fileDownloader from "src/shared/function/fileDownloader";
import useAuth from "src/shared/hooks/useAuth";
import useDirection from "src/shared/hooks/useDirection";
import useDomain from "src/shared/hooks/useDomain";
import useSWR from "swr";
import Login from "../Login";
import LayoutPanelComponent from "./Layout.Panel.Component";
import LayoutPublicComponent from "./Layout.Public.Component";
import TagManager from "react-gtm-module";

const MainLayout = ({ children }: any) => {
  const {
    location: { pathname },
  } = useHistory();
  const { isLogedIn } = useAuth();
  const Layout = pathname.split("/")[1];
  const { direction, lng } = useDirection();
  const domainData = useDomain();

  const { data: activeThemeData, isValidating: isValidatingActiveTheme } =
    useSWR(domainData ? `/theme/activeTheme` : null, {
      onSuccess: (data) => {
        let modifyer = {};

        if (activeThemeData) {
          const { modifyVar } = activeThemeData;
          if (modifyVar) {
            modifyer = modifyVar;
          }
        }

        if (domainData) {
          const { primaryColor } = domainData;
          modifyer = { ...modifyer, "@primary-color": primaryColor };
        }
        if (Object.values(modifyer)[0]) {
          window?.less?.modifyVars(modifyer);
        }
      },
    });

  const tagManagerArgs = {
    gtmId: domainData?.googleTagManager || "",
  };

  TagManager.initialize(tagManagerArgs);

  if (!domainData && process.env.NODE_ENV != "development") return <LoadingC />;
  const layoutSwitcher = () => {
    if (String(Layout) === "panel") {
      if (isLogedIn) {
        return (
          <>
            <script
              dangerouslySetInnerHTML={{
                __html: `${domainData?.scripts}`,
              }}
            />
            <LayoutPanelComponent children={children} domainData={domainData} />
          </>
        );
      } else {
        return <Login />;
      }
    } else {
      return (
        <>
          <script
            dangerouslySetInnerHTML={{
              __html: `${domainData?.scripts}`,
            }}
          />
          <LayoutPublicComponent children={children} domainData={domainData} />
        </>
      );
    }
  };
  return (
    <>
      <ConfigProvider
        direction={direction || "rtl"}
        componentSize={activeThemeData?.size || "large"}
        locale={lng == "fa-IR" || !lng ? fa_IR : en_US}
      >
        <Helmet>
          <title> {`${domainData?.name}` || "mrtag"} </title>
          <meta name="description" content={domainData?.description} />
          <meta name="theme-color" content={domainData?.primaryColor} />
          <link rel="icon" href={fileDownloader(domainData?.favIconPath)} />
          <link
            rel="apple-touch-icon"
            href={fileDownloader(domainData?.favIconPath)}
          />
        </Helmet>
        <GlobalStyle
          dir={direction || "rtl"}
          classes={activeThemeData?.classes}
        />
        {(function () {
          {
            if (String(Layout) === "panel") {
              if (isLogedIn) {
                return (
                  <LayoutPanelComponent
                    children={children}
                    domainData={domainData}
                  />
                );
              } else {
                return <Login />;
              }
            } else {
              return (
                <LayoutPublicComponent
                  children={children}
                  domainData={domainData}
                />
              );
            }
          }
        })()}
      </ConfigProvider>
    </>
  );
};

export default MainLayout;
